import { Grid2 } from '@mui/material';

function HeroSection() {
  return (
    <Grid2>
        <h1>Welcome to Animal Crossing Dex</h1>
        <h2>An encyclopedia based on the hit Nintendo franchise, Animal Crossing.</h2>
    </Grid2>
    );
}

export default HeroSection;
